var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page"
  }, [_vm.procedureList.length != 0 ? _c("div", {
    staticStyle: {
      width: "100px",
      "margin-right": "20px"
    }
  }, [_c("procedure", {
    attrs: {
      list: _vm.procedureList,
      step: _vm.step + 1
    }
  })], 1) : _vm._e(), _vm.scheduleList.length != 0 ? _c("div", {
    staticStyle: {
      width: "200px",
      "overflow-y": "auto"
    }
  }, [_c("schedule", {
    attrs: {
      list: _vm.scheduleList,
      scheduleInfo: _vm.scheduleInfo
    },
    on: {
      go: _vm.goInfoFun
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "infoBox",
    staticStyle: {
      flex: "1"
    }
  }, [_c("div", {
    staticClass: "name",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t(this.scheduleInfo.name)))]), _vm.detailsObj ? _c("div", {
    staticClass: "operationBox"
  }, [_vm.detailsObj.renderState == "COPYWRITING" ? _c("div", {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c("a-result", {
    attrs: {
      status: "warning"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c("a-icon", {
          style: {
            color: "#000"
          },
          attrs: {
            type: _vm.detailsObj.copywritingInfo.copywritingIconName
          }
        })];
      },
      proxy: true
    }, {
      key: "extra",
      fn: function () {
        return [_c("div", {
          staticClass: "cont"
        }, [_vm._v(" " + _vm._s(_vm.$t(_vm.detailsObj.copywritingInfo.copywriting)) + " ")])];
      },
      proxy: true
    }], null, false, 2887839040)
  })], 1) : _vm._e(), _vm.detailsObj.sharedNodeInfo.length != 0 ? _c("shared-node", {
    attrs: {
      infoList: _vm.detailsObj.sharedNodeInfo,
      editableAreaInfo: _vm.detailsObj.editableAreaInfo
    }
  }) : _vm._e(), _vm.detailsObj.initialNodeInfo.claimsTypeId && _vm.scheduleInfo.step != 0 || _vm.scheduleInfo.step == 0 && _vm.scheduleInfo.operationAt ? _c("claims-info", {
    attrs: {
      claimsInfo: _vm.detailsObj.initialNodeInfo,
      type: "claim",
      policyId: _vm.detailsObj.policyId
    }
  }) : _vm._e()], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };